// Role guard component — PSD §11.3 (F11.1). Presentation layer.

import type { ReactNode } from 'react';
import { useSettings } from '../store/selectors';
import { hasPermission, type Permission, type Role } from './roles';

interface RoleGateProps {
  allow: Permission[];
  role?: Role;
  fallback?: ReactNode;
  children: ReactNode;
}

/** Conditionally render children only if the current user's role has ALL listed permissions. */
export function RoleGate({ allow, role, fallback = null, children }: RoleGateProps): ReactNode {
  const settings = useSettings();
  const currentRole = role ?? settings.rbacRole;
  const ok = allow.every((p) => hasPermission(currentRole, p));
  return ok ? <>{children}</> : <>{fallback}</>;
}
